<template>
    <div class="newIndex">
        <div class="box1">
            <div class="active-notice">
                <div class="box-title">
                    <span class="active-notice-icon">一站式办理</span>
                </div>
                <div class="box-content">
                    <ul>
                        <li class="yzList" v-for="(item,index) in yzList" :key="index">
                            <img :src="item.url" alt="">
                        </li>
                    </ul>
                </div>
            </div>
            <div class="active-notice">
                <div class="box-title">
                    <span class="active-notice-icon">数据统计</span>
                </div>
                <div class="box-content">
                    <div class="conBox leftContent">
                        <ul>
                            <li class="sjList">待处理事件：<span>{{statisticsList.dclsj}}</span></li>
                            <li class="sjList">待处理工作：<span>{{statisticsList.dclgz}}</span></li>
                            <li class="sjList">待参加活动：<span>{{statisticsList.dcjhd}}</span></li>
                            <li class="sjList">待参加活动：<span>{{statisticsList.dcjhd}}</span></li>
                            <li class="sjList">待参加会议：<span>{{statisticsList.dcjhy}}</span></li>
                            <li class="sjList">待处理纠纷：<span>{{statisticsList.dcljf}}</span></li>
                        </ul>
                    </div>
                    <div class="conBox rightContent">
                        <div id="dangzuzhi"
                             style="width: 300px; height: 300px;">

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box2">
            <div class="box2Content">
                <el-tabs v-model="workType" type="border-card" @tab-click="workClick">
                    <el-tab-pane label="我的工作" name="1">
                        <div class="workBox">
                            <div class="work1">
                                <div class="work1Title">日常工作</div>
                                <div class="work1Content">
                                    <ul>
                                        <li>
                                            <el-row :gutter="20">
                                                <el-col :span="12">考勤</el-col>
                                                <el-col :span="12" class="text-center" style="color: #1394e7">{{workList.kq}}
                                                </el-col>
                                            </el-row>
                                        </li>
                                        <li>
                                            <el-row :gutter="20">
                                                <el-col :span="12">巡查</el-col>
                                                <el-col :span="12" class="text-center" style="color: #eb631b">{{workList.xc}}次
                                                </el-col>
                                            </el-row>
                                        </li>
                                        <li>
                                            <el-row :gutter="20">
                                                <el-col :span="12">数据更新</el-col>
                                                <el-col :span="12" class="text-center" style="color: #da08e8">{{workList.sjgx}}次
                                                </el-col>
                                            </el-row>
                                        </li>
                                        <li>
                                            <el-row :gutter="20">
                                                <el-col :span="12">网格日志</el-col>
                                                <el-col :span="12" class="text-center" style="color: #219b1f">{{workList.wgrz}}个
                                                </el-col>
                                            </el-row>
                                        </li>
                                        <li>
                                            <el-row :gutter="20">
                                                <el-col :span="12">网格走访</el-col>
                                                <el-col :span="12" class="text-center" style="color: #e9062e">{{workList.wgzf}}次
                                                </el-col>
                                            </el-row>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                            <div class="work1">
                                <div class="work1Title">网格事务</div>
                                <div class="work1Content">
                                    <ul>
                                        <li>
                                            <el-row :gutter="20">
                                                <el-col :span="12">证件办理</el-col>
                                                <el-col :span="12" class="text-center" style="color: #1394e7">{{workList.zjbl}}
                                                </el-col>
                                            </el-row>
                                        </li>
                                        <li>
                                            <el-row :gutter="20">
                                                <el-col :span="12">网格事件</el-col>
                                                <el-col :span="12" class="text-center" style="color: #eb631b">{{workList.wgsj}}次
                                                </el-col>
                                            </el-row>
                                        </li>
                                        <li>
                                            <el-row :gutter="20">
                                                <el-col :span="12">议事协商</el-col>
                                                <el-col :span="12" class="text-center" style="color: #da08e8">{{workList.ysxs}}次
                                                </el-col>
                                            </el-row>
                                        </li>
                                        <li>
                                            <el-row :gutter="20">
                                                <el-col :span="12">党建会议</el-col>
                                                <el-col :span="12" class="text-center" style="color: #219b1f">{{workList.djhy}}个
                                                </el-col>
                                            </el-row>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="workBox workBoxRight">
                            <div class="work1Title">
                                <img src="../../../assets/images/newIndex/my.png" alt="" class="myTopImg">
                                我的排名
                            </div>
                            <div class="workRightContent">
                                <div class="workRightTitle">
                                    个人排名
                                </div>
                                <div class="workRightList">
                                    <ul>
                                        <li>
                                            <img src="../../../assets/images/newIndex/top1.png" alt="">
                                            <span class="topNum">1</span>
                                            <span class="topName">李某某</span>
                                        </li>
                                        <li>
                                            <img src="../../../assets/images/newIndex/top2.png" alt="">
                                            <span class="topNum">2</span>
                                            <span class="topName">李某某</span>
                                        </li>
                                        <li>
                                            <img src="../../../assets/images/newIndex/top3.png" alt="">
                                            <span class="topNum">3</span>
                                            <span class="topName">李某某</span>
                                        </li>
                                        <li>
                                            <span class="zan"></span>
                                            <span class="topNum">4</span>
                                            <span class="topName">李某某</span>
                                        </li>
                                        <li>
                                            <span class="zan"></span>
                                            <span class="topNum">5</span>
                                            <span class="topName">李某某</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="workRightContent">
                                <div class="workRightTitle">
                                    所在网格排名
                                </div>
                                <div class="workRightList">
                                    <ul>
                                        <li>
                                            <img src="../../../assets/images/newIndex/top1.png" alt="">
                                            <span class="topNum">1</span>
                                            <span class="topName">第一网格</span>
                                        </li>
                                        <li>
                                            <img src="../../../assets/images/newIndex/top2.png" alt="">
                                            <span class="topNum">2</span>
                                            <span class="topName">第一网格</span>
                                        </li>
                                        <li>
                                            <img src="../../../assets/images/newIndex/top3.png" alt="">
                                            <span class="topNum">3</span>
                                            <span class="topName">第一网格</span>
                                        </li>
                                        <li>
                                            <span class="zan"></span>
                                            <span class="topNum">4</span>
                                            <span class="topName">第一网格</span>
                                        </li>
                                        <li>
                                            <span class="zan"></span>
                                            <span class="topNum">5</span>
                                            <span class="topName">第一网格</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </el-tab-pane>
                    <el-tab-pane label="事件受理" name="2">
                        <el-radio-group v-model="radio1" fill="#787676" @change="sjChange">
                            <el-radio-button :label="'事件指派('+showData.zp+')'"></el-radio-button>
                            <el-radio-button :label="'回退审核('+showData.ht+')'"></el-radio-button>
                            <el-radio-button :label="'延期审核('+showData.yq+')'"></el-radio-button>
                            <el-radio-button :label="'作废审核('+showData.zf+')'"></el-radio-button>
                            <el-radio-button :label="'结案审核('+showData.ja+')'"></el-radio-button>
                        </el-radio-group>
                        <div class="mt-20">
                            <el-table
                                    ref="singleTable"
                                    :data="tableData"
                                    :header-cell-style="{ background: '#f8fafa' }"
                                    size="mini"
                                    border
                                    align="center"
                                    current-row-key
                                    highlight-current-row
                            >
                                <!-- <el-table-column type="selection" align="center" width="50"></el-table-column> -->
                                <el-table-column
                                        align="center"
                                        prop="eventNumber"
                                        width="160"
                                        label="事件编号"
                                ></el-table-column>
                                <el-table-column align="center" prop="orgName" width="130"
                                                 label="处理单位"></el-table-column>
                                <el-table-column
                                        align="center"
                                        prop="personName"
                                        width="100"
                                        label="处理人员"
                                ></el-table-column>
                                <el-table-column align="center" prop="launch" width="100" label="上报人"></el-table-column>
                                <el-table-column
                                        align="center"
                                        prop="eventSource"
                                        width="120"
                                        label="事件来源"
                                ></el-table-column>
                                <el-table-column prop="eventDescribe" width="300" label="事件描述">
                                    <template slot-scope="scope">
                                        <p
                                                :title="scope.row.eventDescribe"
                                                style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                                        >{{scope.row.eventDescribe}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        align="center"
                                        prop="createDate"
                                        width="160"
                                        label="登记时间"
                                ></el-table-column>
                                <el-table-column
                                        align="center"
                                        width="120"
                                        prop="eventTypeName"
                                        label="大类名称"
                                ></el-table-column>
                                <el-table-column
                                        align="center"
                                        prop="eventGroupName"
                                        width="150"
                                        label="小类名称"
                                >
                                    <template slot-scope="scope">
                                        <p
                                                :title="scope.row.eventGroupName"
                                                style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                                        >{{scope.row.eventGroupName}}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        align="center"
                                        :formatter="formatter"
                                        prop="approvalStatus"
                                        label="事件状态"
                                ></el-table-column>
                                <el-table-column
                                        align="center"
                                        prop="deadline"
                                        width="160"
                                        label="到期时间"
                                ></el-table-column>
                                <el-table-column
                                        align="center"
                                        prop="createDate"
                                        width="100"
                                        label="是否逾期"
                                >
                                    <template slot-scope="scope">
                                        <span>{{scope.row.overdue ==1?'是':'否'}}</span>
                                    </template>
                                </el-table-column>
                                <!--  -->
                                <el-table-column align="center" label="操作" width="100" fixed="right">
                                    <template slot-scope="scope">
                                        <el-tooltip
                                                v-if="activeName=='1'"
                                                class="item"
                                                effect="light"
                                                content="去处理"
                                                placement="top-start"
                                                v-show="activeName == '1'"
                                        >
                                            <button
                                                    class="tabBtn el-icon-set-up tabBtn-edit"
                                                    @click="toUrl"
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                                v-if="activeName!='1'"
                                                class="item"
                                                effect="light"
                                                content="审核"
                                                placement="top-start"
                                        >
                                            <button
                                                    class="tabBtn el-icon-document-checked tabBtn-audit"
                                                    @click="showDialog(scope.row,'check')"
                                            ></button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                    @current-change="handleCurrentChange"
                                    :current-page="pageConfig.pageNo"
                                    :page-size="pageConfig.pageSize"
                                    layout="total, prev, pager, next, jumper"
                                    :total="pageConfig.total"
                            ></el-pagination>
                        </div>

                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <div class="rightAllBox">
            <div class="rightAllTitleBox">
                <div class="rightAllTitle">
                    <img src="../../../assets/images/newIndex/rightWz.png" alt="">
                    第一网格
                </div>
                <div class="wgState">
                    工作状态：<span>开会</span>
                </div>
            </div>
            <div class="wgzl">
                <div class="wgzlTitle">
                    网格资料
                    <span class="wgzlTitleRight">更多></span>
                </div>
                <div class="wgzlContent">
                    <ul>
                        <li class="wgzlText">所属社区：月亮湖社区</li>
                        <li class="wgzlText">类型：网格</li>
                        <li class="wgzlText">住户人数：865</li>
                        <li class="wgzlText">住户数量：1234</li>
                        <li class="wgzlText">党组织数量：20</li>
                        <li class="wgzlText">网格办事处：人民路远东国际广场</li>
                    </ul>
                </div>
            </div>
            <div class="wgzl">
                <div class="wgzlTitle">
                    重点人员（10）
                </div>
                <div class="wgzlContent">
                    <ul>
                        <li class="wgzlText"><img src="../../../assets/images/newIndex/rightIcon.png" alt="">李静
                            （网格长-15034567890）
                        </li>
                        <li class="wgzlText"><img src="../../../assets/images/newIndex/rightIcon.png" alt="">李静
                            （网格长-15034567890）
                        </li>
                        <li class="wgzlText"><img src="../../../assets/images/newIndex/rightIcon.png" alt="">李静
                            （网格长-15034567890）
                        </li>
                        <li class="wgzlText"><img src="../../../assets/images/newIndex/rightIcon.png" alt="">李静
                            （网格长-15034567890）
                        </li>
                        <li class="wgzlText"><img src="../../../assets/images/newIndex/rightIcon.png" alt="">李静
                            （网格长-15034567890）
                        </li>
                        <li class="wgzlText"><img src="../../../assets/images/newIndex/rightIcon.png" alt="">李静
                            （网格长-15034567890）
                        </li>
                        <li class="wgzlText"><img src="../../../assets/images/newIndex/rightIcon.png" alt="">李静
                            （网格长-15034567890）
                        </li>
                        <li class="wgzlText"><img src="../../../assets/images/newIndex/rightIcon.png" alt="">李静
                            （网格长-15034567890）
                        </li>
                        <li class="wgzlText"><img src="../../../assets/images/newIndex/rightIcon.png" alt="">李静
                            （网格长-15034567890）
                        </li>
                        <li class="wgzlText"><img src="../../../assets/images/newIndex/rightIcon.png" alt="">李静
                            （网格长-15034567890）
                        </li>
                    </ul>
                </div>
            </div>
            <div class="wgzl">
                <div class="wgzlTitle">
                    地图信息
                    <div class="rightBox">
                        <img src="../../../assets/images/newIndex/dtRight.png" alt="">
                    </div>
                </div>
                <div class="wgzlContent">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import Echart from "./Echart";
    import request from "../../../utils/request";
    import {post} from "../../../api/requrestHttp";

    export default {
        data() {
            return {
                yzList: [
                    {id: 1, url: require('../../../assets/images/newIndex/list1.png')},
                    {id: 2, url: require('../../../assets/images/newIndex/list2.png')},
                    {id: 3, url: require('../../../assets/images/newIndex/list3.png')},
                    {id: 4, url: require('../../../assets/images/newIndex/list4.png')},
                    {id: 5, url: require('../../../assets/images/newIndex/list5.png')},
                    {id: 6, url: require('../../../assets/images/newIndex/list6.png')},
                    {id: 7, url: require('../../../assets/images/newIndex/list7.png')},
                    {id: 8, url: require('../../../assets/images/newIndex/list8.png')},
                    {id: 9, url: require('../../../assets/images/newIndex/list9.png')},
                    {id: 10, url: require('../../../assets/images/newIndex/add.png')},
                ],
                peopleList: [
                    {name: '党员', value: 20},
                    {name: '残疾人', value: 20},
                    {name: '退役军人', value: 20},
                    {name: '志愿者', value: 20},
                ],
                workType: '1',
                radio1: '',
                //表格数据
                multipleSelection: [],
                tableData: [],
                pageConfig: {
                    pageSize: 5,
                    total: 0,
                    pageNo: 1
                },
                searchlist: {
                    createDate: []
                },
                permission: "sj:sjsl:zp",
                activeName: "1",
                showData: {
                    ht: 0,
                    ja: 0,
                    yq: 0,
                    zf: 0,
                    zp: 0
                },
                //事件状态
                statusMap: [
                    {value: 1, label: "待批转"},
                    // { value: 2, label: "撤销中" },
                    // { value: 3, label: "已撤销" },
                    {value: 4, label: "已接收"},
                    {value: 5, label: "结案中"},
                    {value: 6, label: "延期中"},
                    {value: 7, label: "回退中"},
                    {value: 8, label: "作废中"},
                    {value: 9, label: "已回访"},
                    {value: 10, label: "已作废"},
                    {value: 11, label: "已虚拟"},
                    {value: 12, label: "已虚拟"},
                    {value: 13, label: "待领取"},
                    {value: 14, label: "已结案"},
                    {value: 15, label: "已延期"}
                ],
                //  纠纷处理
                jfTableData: [],

                jfPageConfig: {
                    pageSize: 5,
                    total: 0,
                    pageNo: 1
                },
                statusObj: {
                    0: "暂存",
                    1: "上报",
                    2: "已受理",
                    3: "退回",
                    4: "作废",
                    5: "处理完毕"
                },
                //  会议直播
                hyTableData: [],
                hyPageConfig: {
                    pageSize: 5,
                    total: 0,
                    pageNo: 1
                },  //  议事协商
                ysTableData: [],
                ysPageConfig: {
                    pageSize: 5,
                    total: 0,
                    pageNo: 1
                },
                approvalStatusTextObj: {
                    0: "待审批",
                    1: "同意",
                    2: "不同意"
                },
                //  一站式办理
                yzsTableData: [],
                yzsPageConfig: {
                    pageSize: 5,
                    total: 0,
                    pageNo: 1
                },

                workList:{
                    kq:'0',
                    xc:'0',
                    sjgx:'0',
                    wgrz:'0',
                    wgzf:'0',
                    zjbl:'0',
                    wgsj:'0',
                    ysxs:'0',
                    djhy:'0',
                },
                statisticsList:{
                    dclsj:'0',
                    dclgz:'0',
                    dcjhd:'0',
                    dcjhy:'0',
                    dcljf:'0',
                }
            }
        },
        methods: {
            getPartyPay() {
                let myChart = this.$echarts.init(document.getElementById("dangzuzhi"));
                // 绘制图表
                myChart.setOption(this.handleOption(this.peopleList));
                let option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        bottom: 10,
                        data: ['直接访问333', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                    },
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius: ['50%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '30',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                {value: 335, name: '直接访问'},
                                {value: 310, name: '邮件营销'},
                                {value: 234, name: '联盟广告'},
                                {value: 135, name: '视频广告'},
                                {value: 1548, name: '搜索引擎'}
                            ]
                        }
                    ]
                };

            },
            //    画图
            handleOption(data) {
                const optionData = {};
                const legendArr = data.map(item => {
                    return item.name;
                });
                optionData.legend = {
                    left: 'center',
                    bottom: 10,
                    data: legendArr,

                    textStyle: {
                        color: "#6D6E72"
                    }
                    // formatter: ["{a|{name}}", "{b|{name}}"].join("\n")
                };
                const seriesData = [
                    {
                        type: "pie",
                        radius: ["30%", "70%"],
                        center: ['50%', '40%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: "inner",
                            formatter: "{d}%"
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: "30",
                                fontWeight: "bold"
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data,
                        left: "50px",
                        color: ['#c9001b', '#191919', '#6d6e72', '#959fa8'],
                    }
                ];
                optionData.series = seriesData;
                return optionData;
            },
            workClick() {

            },
            sjChange(val) {
                console.log(val.split('(')[0]);
                let type = val.split('(')[0];
                let typeId = '';
                if (type == '事件指派') {
                    this.activeName = '1';
                }
                if (type == '回退审核') {
                    this.activeName = '7';
                }
                if (type == '延期审核') {
                    this.activeName = '6';
                }
                if (type == '作废审核') {
                    this.activeName = '8';
                }
                if (type == '结案审核') {
                    this.activeName = '5';
                }
                this.getPageDatas();
            },
            async eventNumberClick(rowVal) {
                if (!rowVal) {
                    this.detail.eventFile1 = [];
                    this.detail.eventFile2 = [];
                    this.detail = {}
                    this.mapMarker.lng = "117.49426";
                    this.mapMarker.lat = "30.656587";
                    this.mapMarker.extDataName = '无';
                    this.mapMarker.extDataDesc = '无';
                    this.$nextTick(() => {
                        this.initMap();
                    });
                    return false;
                }

                this.eventClickNum = this.eventClickNum + 1;
                let params = JSON.stringify({id: rowVal.id});
                var res = await request({
                    url: "/admin/event/info/getEvent",
                    method: "POST",
                    data: params
                });
                if (res.code == 200) {
                    // console.log(res.content)
                    this.detail = res.content;
                    this.detail.statusName = this.formatter(
                        res.content.approvalStatus
                    );
                    //  var arr = res.content.enclosure.split(",");
                    // this.detail.enclosure = [];
                    this.detail.eventFile1 = [];
                    this.detail.eventFile2 = [];
                    res.content.eventFile.forEach(val => {
                        if (val.state == "1") {
                            this.detail.eventFile1.push(val.url);
                        } else {
                            this.detail.eventFile2.push(val.url);
                        }
                    });

                    //处理流程
                    this.detail.logs = res.content.eventProcessList;
                    this.mapMarker.title = res.content.eventNumber;
                    if (res.content.longitude) {
                        this.mapMarker.lng = res.content.longitude;
                        this.mapMarker.lat = res.content.latitude;
                    } else {
                        this.mapMarker.lng = "117.49426";
                        this.mapMarker.lat = "30.656587";
                    }
                    this.mapMarker.extDataName = res.content.eventDescribe;
                    this.mapMarker.extDataDesc = res.content.addressDetail;
                    this.$nextTick(() => {
                        this.initMap();
                    });
                    if (this.eventClickNum > 1) {
                        // document.getElementById("detailBox").scrollIntoView();
                    }
                } else {
                    this.$message({
                        message: "获取数据异常",
                        type: "error"
                    });
                }
            },
            formatter(row, column) {
                let statusName = "";
                this.statusMap.forEach(item => {
                    if (row.approvalStatus == item.value) {
                        statusName = item.label;
                    }
                });
                return statusName;
            },
            //分页
            //事件
            handleCurrentChange(val) {
                this.pageConfig.pageNo = val;
                this.getPageDatas();
            },
            //纠纷处理
            jfCurrentChange(val) {
                this.jfPageConfig.pageNo = val;
                this.getJfDataList();
            },
            //会议直播
            hyCurrentChange(val) {
                this.hyPageConfig.pageNo = val;
                this.getHyDataList();
            }, //议事协商
            ysleCurrentChange(val) {
                this.ysPageConfig.pageNo = val;
                this.getYsDataList();
            }, //一站式办理
            yzsCurrentChange(val) {
                this.yzsPageConfig.pageNo = val;
                this.getYzsDataList();
            },
            async getPageDatas() {
                this.searchlist.approvalStatus = this.activeName;
                this.searchlist.pageNo = this.pageConfig.pageNo;
                this.searchlist.pageSize = this.pageConfig.pageSize;
                try {
                    this.searchlist.startTime = this.searchlist.createDate[0]
                        ? this.searchlist.createDate[0] + ' 00:00:00'
                        : "";
                    this.searchlist.endTime = this.searchlist.createDate[1]
                        ? this.searchlist.createDate[1] + ' 23:59:59'
                        : "";
                } catch (error) {
                    this.searchlist.startTime = ''
                    this.searchlist.endTime = ''
                }

                let params = JSON.stringify({...this.searchlist, createDate: ""});
                var res = await request({
                    url: "/admin/event/info/listEvent",
                    method: "POST",
                    data: params
                });
                if (res.code == 200 && res.content != null) {
                    // console.log( res.content)
                    this.pageConfig.total = res.content.count;
                    this.tableData = res.content.list;
                    // if(res.content.list.length == 1){
                    //     console.log(res.content.list[0].approvalStatus)
                    //     this.activeName == res.content.list[0].approvalStatus
                    // }
                    if (res.content.count > 0) {
                        //默认选中table状态
                        this.$refs.singleTable.setCurrentRow(res.content.list[0]);
                    }
                } else {
                    this.detail = {};
                    this.detail.isShow = false;
                    this.$message({
                        message: "数据加载异常：",
                        type: "error"
                    });
                }
                post("/admin/event/info/findEventTypeStatistics", {
                    orgId: this.$store.state.info.orgId,
                    ...this.searchlist,
                    createDate: "",
                    approvalStatus: ''
                }).then(res => {
                    this.showData = res.content
                        ? res.content
                        : {
                            ht: 0,
                            ja: 0,
                            yq: 0,
                            zf: 0,
                            zp: 0
                        };

                });
            },
            toUrl() {
                if (this.workType == '2') {
                    this.$router.push({path: "/twoNetworkConvergenceAccept"})
                }
                if (this.workType == '3') {
                    this.$router.push({path: "/CAEventOrders"})
                }
                if (this.workType == '4') {
                    this.$router.push({path: "/LiveMeeting"})
                }
                if (this.workType == '5') {
                    // this.$router.push({path: "/LiveMeeting"})
                }
                if (this.workType == '6') {
                    this.$router.push({path: "/communityIssueTitle"})
                }
                if (this.workType == '7') {
                    this.$router.push({path: "/oneStopProcessing"})
                }

            },

            //我的工作统计
            getMyWork() {
                let personId=localStorage.getItem("userId");
                post("/admin/statistics/info/dailyWork", {
                    personId:personId
                }).then(res => {
                    if (res.code == 200) {
                        if (res.content) {
                            res.content.forEach( item => {
                                if(item.name=="考勤"){
                                    this.workList.kq=item.total;
                                }
                                if(item.name=="巡查"){
                                    this.workList.xc=item.total;
                                }
                                if(item.name=="数据更新"){
                                    this.workList.sjgx=item.total;
                                }
                                if(item.name=="网格日志"){
                                    this.workList.wgrz=item.total;
                                }
                                if(item.name=="网格走访"){
                                    this.workList.wgzf=item.total;
                                }
                            })
                        }
                    } else {
                        console.log(res);
                    }
                });
                post("/admin/statistics/info/gridTransactions", {
                    personId:personId
                }).then(res => {
                    if (res.code == 200) {
                        if (res.content) {
                            res.content.forEach( item => {
                                if(item.name=="证件办理"){
                                    this.workList.zjbl=item.total;
                                }
                                if(item.name=="网格事件"){
                                    this.workList.wgsj=item.total;
                                }
                                if(item.name=="议事协商"){
                                    this.workList.ysxs=item.total;
                                }
                                if(item.name=="党建会议"){
                                    this.workList.djhy=item.total;
                                }
                            })
                        }
                    } else {
                        console.log(res);
                    }
                });
            },
            //    数据统计
            getDataStatistics(){
                let orgId=localStorage.getItem("orgId");
                let data={};
                let dataId={};
                if(orgId){
                    data={
                        orgId:orgId
                    };
                    dataId={
                        id:orgId
                    }
                }else {
                    data={};
                    dataId={};
                }
                post("/admin/statistics/info/dataStatistics", data).then(res => {
                    if (res.code == 200) {
                        if (res.content) {
                            this.statisticsList=res.content;
                        }
                    } else {
                        console.log(res);
                    }
                });
                post("/admin/statistics/info/personStatistics", dataId).then(res => {
                    if (res.code == 200) {
                        if (res.content) {
                            // this.statisticsList=res.content;
                            this.peopleList= [
                                {name: '党员', value: res.content.dy},
                                {name: '残疾人', value: res.content.cjr},
                                {name: '退役军人', value: res.content.tyjr},
                                {name: '志愿者', value: res.content.zyz},
                            ];
                            this.getPartyPay();
                        }
                    } else {
                        console.log(res);
                    }
                });
            }
        },
        mounted() {
            this.getPageDatas();
            this.getJfDataList();
            this.getHyDataList();
            this.getYsDataList();
            this.getYzsDataList();
            this.getMyWork();
            this.getDataStatistics();
            post("/admin/event/info/findEventTypeStatistics", {
                orgId: this.$store.state.info.orgId,
                ...this.searchlist,
                createDate: "",
                approvalStatus: ''
            }).then(res => {
                this.showData = res.content
                    ? res.content
                    : {
                        ht: 0,
                        ja: 0,
                        yq: 0,
                        zf: 0,
                        zp: 0
                    };
                this.radio1 = "事件指派(" + this.showData.zp + ")"
            });
        }
    }
</script>

<style lang="less" scoped>
    a {
        text-decoration: none;
    }

    .mt-20 {
        margin-top: 20px;
    }

    .newIndex {
        box-sizing: border-box;
        padding: 20px 20px 50px;
        width: calc(100vw - 168px);
        min-width: 1000px;
        background-color: #f4f4f4;
        position: relative;
    }

    .box1 {
        /*display: flex;*/
        /*justify-content: space-between;*/
        /*align-items: center;*/
        height: 390px;
    }

    .active-notice {
        width: 679px;
        height: 100%;
        background: #fff;
        float: left;
        margin: 5px;
    }

    .active-notice img {
        width: 100%;
        height: auto;
    }

    .handle-list {
        box-sizing: border-box;
        padding: 0 20px;
    }

    .handle {
        flex: 1;
        // width: 625px;
        height: 100%;
        background: #fff;
        overflow: hidden;
    }

    .box-title {
        display: flex;
        justify-content: space-between;
        line-height: 50px;
        height: 50px;
        box-sizing: border-box;
        padding-left: 20px;
        padding-right: 20px;
    }

    .active-notice-icon {
        font-weight: bold;
        font-size: 18px;
    }

    .box-content {
        padding: 15px;
        box-sizing: border-box;
    }

    .yzList {
        width: 16%;
        float: left;
        margin: 2%;
    }

    .yzList img {
        width: 100%;
    }

    .conBox {
        width: 48%;
        height: 303px;
        float: left;

    }

    .leftContent {
        border: 1px solid #F2F0F1;
        background-color: #faf9fa;
    }

    .conBox ul {
        width: 100%;
        height: 100%;
        padding-left: 10px;
        padding-top: 20px;
    }

    .sjList {
        width: 50%;
        float: left;
        font-size: 14px;
        font-weight: 400;
        color: rgba(94, 93, 95, 1);
        line-height: 30px;
        padding-left: 25px;
        box-sizing: border-box;
        background: url("../../../assets/images/newIndex/listStyle.png") no-repeat -2px center;
        background-size: auto 100%;
    }

    .sjList span {
        color: #E80000;
        font-size: 16px;
    }

    .box2 {
        /*height: 390px;*/
        width: 1378px;
        margin-top: 10px;
        padding: 5px;
        box-sizing: border-box;
        /*background-color: #fff;*/
    }

    .box2Content {
        background-color: #fff;
        width: 100%;
        height: 100%;
    }

    .workBox {
        width: 50%;
        margin-top: 20px;
        height: 500px;
        float: left;
    }

    .work1 {
        width: 40%;
        height: 90%;
        border: 1px solid #F2F0F1;
        background-color: #faf9fa;
        padding: 20px;
        float: left;
        margin-right: 10px;
    }

    .work1Title {
        font-size: 18px;
        margin-top: 20px;
        margin-bottom: 30px;
        font-weight: bold;
    }

    .work1Content li {
        line-height: 40px;
        font-size: 14px;
    }

    .text-center {
        text-align: center;
    }

    .workBoxRight {
        border: 1px solid #F2F0F1;
        background-color: #faf9fa;
        box-sizing: border-box;
        padding: 20px;
    }

    .myTopImg {
        vertical-align: middle;
        margin-right: 10px;
    }

    .workRightContent {
        width: 50%;
        padding-left: 40px;
        float: left;
        box-sizing: border-box;
    }

    .workRightTitle {
        display: inline-block;
        border: 1px solid #F2F0F1;
        padding: 5px 20px;
        border-radius: 10px;
    }


    .workRightList li {
        line-height: 30px;
    }

    .workRightList {
        margin-top: 20px;
    }

    .workRightList li img {
        width: 20px;
        vertical-align: middle;
    }

    .zan {
        display: inline-block;
        width: 20px;
    }

    .workRightList .topNum {
        display: inline-block;
        width: 20px;
        height: 20px;
        color: #ffffff;
        background: #e90001;
        text-align: center;
        line-height: 20px;
        border-radius: 50%;
        margin-left: 20px;
        margin-right: 10px;
    }

    .workRightList .topName {
        /*font-size: 14px;*/
    }

    .rightAllBox {
        position: absolute;
        right: 0;
        top: 0;
        width: calc(100% - 1410px);

    }

    .rightAllTitleBox {
        width: 100%;
        background-color: #fff;
        padding: 15px;

    }

    .rightAllTitleBox img {
        vertical-align: middle;
        margin-right: 5px;
    }

    .rightAllTitle {
        font-size: 18px;
        font-weight: bold;
    }

    .wgState {
        font-size: 14px;
        color: #737373;
        margin-top: 15px;
    }

    .wgState span {
        color: #D40000;
    }

    .wgzl {
        background-color: #fff;
        margin-top: 10px;
        padding: 15px;
    }

    .wgzlTitle {
        font-size: 14px;
        font-weight: bold;
    }

    .wgzlTitle span {
        float: right;
        font-size: 12px;
        color: #DE0606;
    }

    .wgzlContent {
        margin-top: 10px;

    }

    .wgzlText {
        color: #585858;
        font-size: 14px;
        line-height: 30px;
    }

    .wgzlText img {
        margin-right: 5px;
        vertical-align: middle;
    }

    .rightBox {
        float: right;
    }
</style>